import * as React from "react";

import { ProminentErrorMessageBox } from "../../Common";

import {
  DeliveryDetailsUserExperience_ProminentErrorAreas,
  useDeliveryDetailsUserExperience_asController,
  useMyBagPresentationModel,
} from "../providers";
import { useCallback } from "react";

export const DeliveryDetailsActions: React.FunctionComponent = () => {
  const {
    handleReviewAndPay:
      deliveryDetailsUserExperience_asController_handleReviewAndPay,
  } = useDeliveryDetailsUserExperience_asController();

  const { presentationMyBagItems } = useMyBagPresentationModel();

  const sendGTMAddShoppingInfo = useCallback(() => {
    if (presentationMyBagItems?.[0]?.sku) {
      const event = {
        event: "add_shipping_info",
        ecommerce: {
          currency: "AUD",
          value: parseFloat(
            document.querySelector(
              "#bbnt-new-checkout-2022--mybag > section > section.side > section.my-bag-summary > div.by-the-numbers > div.totalValueBreakdown > div.total-inc-gst > p.the-price.add-price > span.value"
            )?.innerText
          ),
          items: presentationMyBagItems.map((item) => ({
            item_id: item.sku,
            item_name: item.title,
            price: item.subtotal,
            quantity: item.howManyOfThisProduct,
          })),
        },
      };

      window.dataLayer?.push(event);
    }
  }, []);

  const handleReviewAndPay: React.MouseEventHandler<HTMLButtonElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        sendGTMAddShoppingInfo();
        deliveryDetailsUserExperience_asController_handleReviewAndPay();
      },
      [deliveryDetailsUserExperience_asController_handleReviewAndPay]
    );

  return (
    <section className="actions">
      <ProminentErrorMessageBox
        notForAnyOfTheseAreas={[
          DeliveryDetailsUserExperience_ProminentErrorAreas.DELETE_ADDRESS,
        ]}
      />

      <button className="review-and-pay" onClick={handleReviewAndPay}>
        <span>{`REVIEW AND PAY`}</span>
      </button>
    </section>
  );
};
